<template>
    <app-popup
        ref="popup"
        :showHeader="true"
        :title="$t('project.follow.progressDate.title')"
        popup-extra-class="left-50"
        @close="onClose"
    >
        <form class="flex flex-col gap-4 p-2" @submit.prevent="validate">
            <div :class="{ 'border border-red-500': error }" data-test="progress-date-field">
                <app-date-input
                    v-model="date"
                    :label="$t('project.follow.planning.refDate')"
                    :required="true"
                ></app-date-input>
            </div>
            <p v-if="error" class="text-red-500" data-test="progress-date-error">
                {{ $t('project.follow.progressDate.required') }}
            </p>
            <app-checkbox v-model="applyToAll" :label="$t('project.follow.progressDate.applyToAll')"></app-checkbox>
            <app-footer @click="validate"></app-footer>
        </form>
        <div style="padding-bottom: 40px"></div>
    </app-popup>
</template>
<script>
import AppPopup from '@/components/app-popup/AppPopup.vue';
import AppDateInput from '@/components/appDateInput/AppDateInput.vue';
import AppCheckbox from '@/components/app-checkbox/AppCheckbox.vue';
import AppFooter from '@/components/appFooter/AppFooter.vue';
import startOfDay from 'date-fns/startOfDay';
import { getProgressDateState, setProgressDate } from './progressDate.service';

export default {
    components: { AppPopup, AppDateInput, AppCheckbox, AppFooter },
    data() {
        return { date: null, applyToAll: false, error: false, resolve: null };
    },
    methods: {
        // Resolves with the date to use for the progress, or null if the user closed the popup.
        getDate() {
            const { date } = getProgressDateState();
            if (date) {
                return Promise.resolve(date);
            }
            this.date = null;
            this.applyToAll = false;
            this.error = false;
            this.$refs.popup.open();
            return new Promise((resolve) => (this.resolve = resolve));
        },
        validate() {
            if (!this.date) {
                this.error = true;
                return;
            }
            const date = startOfDay(this.date);
            if (this.applyToAll) {
                setProgressDate(date);
            }
            this.finish(date);
            this.$refs.popup.close();
        },
        onClose() {
            this.finish(null);
        },
        finish(date) {
            if (this.resolve) {
                this.resolve(date);
                this.resolve = null;
            }
        },
    },
};
</script>
